import { ReactNode, createContext, useContext } from "react";
import { useNewTransaction } from "./new-transaction.hook";

const NewTransactionContext = createContext(
  {} as ReturnType<typeof useNewTransaction>
);
export function useNewTransactionContext() {
  return useContext(NewTransactionContext);
}

interface NewTransactionProviderProps {
  children: ReactNode;
}
export function NewTransactionProvider({
  children,
}: NewTransactionProviderProps) {
  return (
    <NewTransactionContext.Provider value={useNewTransaction()}>
      {children}
    </NewTransactionContext.Provider>
  );
}
